import { render, staticRenderFns } from "./iSpringQuizInfoView.vue?vue&type=template&id=583ecccf&"
import script from "./iSpringQuizInfoView.vue?vue&type=script&lang=js&"
export * from "./iSpringQuizInfoView.vue?vue&type=script&lang=js&"
import style0 from "./iSpringQuizInfoView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports